import { Card } from '@material-ui/core'
import { format } from 'date-fns'
import { set } from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import DialogDeliveryInstructions from '../components/checkout/DialogDeliveryInstructions'
import { ArticleLarge, SpinnerCard } from '../components/common/Layout'
import { LocationOrderStatusOld } from '../components/common/Location'
import { OrderDetails, OrderSummary } from '../components/common/OrderSummary'
import { Referral } from '../components/community/Referral'
import AutoFavoriteModal from '../components/confirmation/AutoFavorite'
import ConfirmationLocation from '../components/confirmation/ConfirmationLocation'
import ContactUsSidebar from '../components/contact-us/ContactUsSidebar'
import { closeAutoFavorite } from '../redux/modules/checkout'
import { loadDeliveryDropoffStart } from '../redux/modules/delivery'
import { loadFavoriteStart } from '../redux/modules/favorite'
import {
  toggleDeliveryInstructionsDialog,
  updateUserSavedLocationStart,
} from '../redux/modules/location'
import { loadMenuStart } from '../redux/modules/menu'
import { loadOrderByIdStart, loadOrderStart } from '../redux/modules/orderDetail'
import { selectCurrentSavedLocation } from '../redux/modules/selectors'
import { loadReasonsByOrder, submitTicket } from '../redux/modules/ticket'

const OrderStatus = ({ order }) => {
  return (
    <h1 className="row center-xs">
      <LocationOrderStatusOld
        extraClasses={{ confirm: true }}
        isConfirmation
        locationStatusClasses="order-status"
        order={order}
        statusText={
          !order.isPastCutoff && order.statusText !== 'Order Cancelled'
            ? 'Thank you for your order!'
            : order.statusText
        }
      />
    </h1>
  )
}

class PageConfirmation extends Component {
  constructor(props) {
    super(props)
    const {
      loadOrderByIdStart,
      loadReasonsByOrder,
      match: {
        params: { orderId },
      },
    } = this.props
    loadOrderByIdStart(orderId)
    loadReasonsByOrder(orderId)
    const timer = setInterval(() => loadOrderByIdStart(orderId), 600000)
    this.state = {
      showOrderSummary: false,
      timer,
    }
  }

  componentDidMount() {
    window && window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps) {
    let {
      loadDeliveryDropoffStart,
      loadFavoriteStart,
      loadMenuStart,
      loadOrderStart,
      match: {
        params: { locationId },
      },
      order,
    } = this.props
    if ((!prevProps.order && order) || (order && order.orderId !== prevProps.order.orderId)) {
      loadOrderStart(format(order.orderDate, 'YYYYMMDD'), locationId)
      loadMenuStart(order.deliveryDropoffId)
      loadDeliveryDropoffStart(order.deliveryDropoffId)
      loadFavoriteStart(order.menuId)
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.timer)
  }

  toggleShowOrderSummary = () => {
    this.setState({ showOrderSummary: !this.state.showOrderSummary })
  }

  render() {
    const {
      autoFavorite,
      closeAutoFavorite,
      curSavedLocation,
      favoriteInfo,
      history,
      isCheckingStatus,
      isLoadingFavorites,
      isUpdatingSavedLocation,
      isWebpSupported,
      loading,
      match: {
        params: { locationId },
      },
      order,
      orders,
      profile,
      reasons,
      showDeliveryInstructionsDialog,
      submitTicket,
      submitting,
      toggleDeliveryInstructionsDialog,
      updateSavedLocationError,
      updateUserSavedLocationStart,
      updatingModal,
    } = this.props

    let autoFavorites = []
    order &&
      favoriteInfo &&
      favoriteInfo.forEach(info => {
        autoFavorites = autoFavorites.concat(
          order.orderItems.filter(item => item.menuItemId === info.menuItemId),
        )
      })

    return (
      <>
        <ConfirmationComponent
          autoFavorite={autoFavorite}
          autoFavorites={autoFavorites}
          closeAutoFavorite={closeAutoFavorite}
          history={history}
          isCheckingStatus={isCheckingStatus}
          isLoadingFavorites={isLoadingFavorites}
          isWebpSupported={isWebpSupported}
          loading={loading}
          locationId={locationId}
          order={order}
          orders={orders}
          profile={profile}
          reasons={reasons}
          showOrderSummary={this.state.showOrderSummary}
          submitTicket={submitTicket}
          submitting={submitting}
          toggleShowOrderSummary={this.toggleShowOrderSummary}
          updatingModal={updatingModal}
        />
        <DialogDeliveryInstructions
          curSavedLocation={curSavedLocation}
          isUpdatingSavedLocation={isUpdatingSavedLocation}
          showDeliveryInstructionsDialog={showDeliveryInstructionsDialog}
          showOnEmptyDeliveryInstructions
          toggleDeliveryInstructionsDialog={toggleDeliveryInstructionsDialog}
          updateSavedLocationError={updateSavedLocationError}
          updateUserSavedLocationStart={updateUserSavedLocationStart}
        />
      </>
    )
  }
}

export const ConfirmationComponent = ({
  autoFavorites,
  closeAutoFavorite,
  isLoadingFavorites,
  loading,
  locationId,
  order,
  reasons,
  showOrderSummary,
  submitTicket,
  submitting,
  toggleShowOrderSummary,
}) => {
  return (
    <ArticleLarge>
      <SpinnerCard spinnerActive={!order || loading}>
        <OrderStatus order={order} />
      </SpinnerCard>
      <div className="row" style={{ margin: '0 -8px' }}>
        <div className="col-xs-12 col-md-8">
          <Card className="WebConV3 referral-card" mb={16}>
            <Referral />
          </Card>
          <SpinnerCard spinnerActive={loading || isLoadingFavorites || submitting}>
            <ConfirmationLocation
              order={order}
              showOrderSummary={showOrderSummary}
              toggleShowOrderSummary={toggleShowOrderSummary}
            />
            {showOrderSummary && (
              <OrderSummary>{order && <OrderDetails order={order} />}</OrderSummary>
            )}
            {autoFavorites.length >= 1 && (
              <AutoFavoriteModal closeAutoFavorite={closeAutoFavorite} items={autoFavorites} />
            )}
          </SpinnerCard>
        </div>
        <aside className="col-xs-12 col-md-4 confirmation-contact-us">
          <ContactUsSidebar
            className="contact-us-form"
            locationId={locationId}
            order={order}
            orderHistorySize
            reasons={reasons}
            showForm
            submitticket={submitTicket}
          />
        </aside>
      </div>
    </ArticleLarge>
  )
}

const mapStateToProps = (state, entryProps) => {
  const { loading, order, orders } = state.orderDetail
  const { profile, updatingModal } = state.profile
  const { isLoadingFavorites } = state.favorite
  const { favoriteInfo } = state.checkout
  const { submitting } = state.ticket
  const { reasons } = state
  const { isWebpSupported } = state.browser
  const {
    isUpdatingSavedLocation,
    showDeliveryInstructionsDialog,
    updateSavedLocationError,
  } = state.location
  const deliveryLocationId = entryProps.match.params.locationId
  const curSavedLocation = selectCurrentSavedLocation(
    set(state, 'location.location.deliveryLocationId', deliveryLocationId),
  )

  return {
    curSavedLocation,
    favoriteInfo,
    isLoadingFavorites,
    isUpdatingSavedLocation,
    isWebpSupported,
    loading,
    order,
    orders,
    profile,
    reasons,
    showDeliveryInstructionsDialog,
    submitting,
    updateSavedLocationError,
    updatingModal,
  }
}

const mapDispatchToProps = {
  closeAutoFavorite,
  loadDeliveryDropoffStart,
  loadFavoriteStart,
  loadMenuStart,
  loadOrderByIdStart,
  loadOrderStart,
  loadReasonsByOrder,
  submitTicket,
  toggleDeliveryInstructionsDialog,
  updateUserSavedLocationStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageConfirmation)
